module.exports = __webpack_public_path__ + "static/media/04-speaker_profile.113fbfb0.webp";